import { getQueryParams } from './getQueryParams';
export function getQueryParam(url: string, key: string): string | null {
    const params = getQueryParams(url);
    return params[key] || null;
}